export function shouldShowAlertForProject(project, profilesRequested = []) {
  const notifications = (profilesRequested || []).filter(
    (n) => n.project === project._id
  )

  if (!notifications.length) return false

  if (!project.lastViewAt) return true

  const lastViewedAt = new Date(project.lastViewAt)
  return notifications.some((n) => new Date(n.date) > lastViewedAt)
}

export function hasProjectNotification(projects = [], profilesRequested = []) {
  return (projects || []).some((p) =>
    shouldShowAlertForProject(p, profilesRequested)
  )
}
